import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconUserLogInProps } from './IconUserLogIn.types'
import * as Styled from './styles/IconUserLogIn.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUserLogIn: FC<IconUserLogInProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUserLogInProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconUserLogInProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11.762 5.32a.814.814 0 0 1 .816-.82h8.25v4.535a.773.773 0 0 1-.226.559.762.762 0 0 1-.555.238h-4.55m-.005 0-2.133 2.133V9.832h-.8a.787.787 0 0 1-.797-.781V5.32M3.176 19.5c.476-2.223 2.152-3.86 4.144-3.86 1.996 0 3.672 1.637 4.145 3.86m-1.731-6.516a2.41 2.41 0 0 1-2.414 2.414 2.413 2.413 0 1 1 0-4.828h2.414Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconUserLogIn
